import type { PaymentMethodType } from '@/types/sendRequest'

export interface PaymentMethodsType {
  id: string
  name: string
  paymentMethod: PaymentMethodType['paymentMethod']
  iconName?: string
  iconSize?: number
  currencyIconUrl?: string
  currencyBgColor?: string | string[]
  displayCurrencyCode?: string
  currencyName?: string
  formattedAmountBalance?: string
  bgIconContainer?: string | string[]
}

const paymentMethods: Omit<PaymentMethodsType, 'id'>[] = [
  {
    name: 'Apple Pay',
    paymentMethod: 'ApplePay',
    iconName: 'applePay',
    iconSize: 42,
    bgIconContainer: '#000000',
  },
  {
    name: 'Card',
    paymentMethod: 'Card',
    iconName: 'cardFilled',
    iconSize: 32,
    bgIconContainer: ['#41FFD1', '#534FFF'],
  },
  {
    name: 'Bank Transfer',
    paymentMethod: 'OnlineBanking',
    iconName: 'bank',
    iconSize: 28,
    bgIconContainer: ['#7866FF', '#4732FF'],
  },
]

// Определяем платформу (в веб-версии показываем все методы)
const isAndroid = false // В веб-версии не скрываем методы
const isIOS = false

export const paymentMethodsList: PaymentMethodsType[] = [...paymentMethods]
  .filter(
    ({ paymentMethod }) =>
      !(isAndroid && paymentMethod === 'ApplePay') &&
      !(isIOS && paymentMethod === 'GooglePay') &&
      // TODO: Временно скрыто - можно быстро вернуть, удалив эту строку
      paymentMethod !== 'OnlineBanking',
  )
  .map((paymentMethod, index) => ({
    id: String(index),
    ...paymentMethod,
  }))
